import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/contract/info/save',
    data: form,
    method: 'post'
  })
export const update = (form) => axios.request({
    url: '/contract/info/update',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `/contract/info/delete/${id}`,
    method: 'delete'
  })

export const getById = (id) => axios.request({
    url: '/contract/info/getById',
    params: { id },
    method: 'get'
  })
  export const later = (form) => axios.request({
    url: '/contract/info/later',
    data: form,
    method: 'post'
  })
  export const again = (form) => axios.request({
    url: '/contract/info/again',
    data: form,
    method: 'post'
  })

  export const getByConUserId = (userId) => axios.request({
    url: '/contract/info/getByUserId',
    params: { userId },
    method: 'get'
  })
